/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react";
import { motion } from "motion/react";

// Animate every page in on route change — a gentle rise + fade that
// respects prefers-reduced-motion via the Motion library defaults.
export const wrapPageElement = ({ element, props }) => (
  <motion.div
    key={props.location.pathname}
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
  >
    {element}
  </motion.div>
);
